<template>
  <div class="text-center section">
    <div class="d_flex_btwn mb_10">
      <h2 class="h2">Leave Calendar</h2>
      <h4 class="color_green">
        <router-link :to="{ name: 'leaves-calender' }"
          >View leave requests</router-link
        >
      </h4>
    </div>
    <v-calendar
      class="custom-calendar max-w-full"
      :masks="masks"
      :attributes="attributes"
      disable-page-swipe
      is-expanded
    >
      <template v-slot:day-content="{ day, attributes }">
        <div class="flex flex-col h-full z-10 overflow-hidden">
          <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
          <div class="flex-grow overflow-y-auto overflow-x-auto">
            <p
              v-for="attr in attributes"
              :key="attr.key"
              class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
              :title="attr.customData.status"
              :class="attr.customData.class"
              @click="showData($event, attr.customData)"
            >
              {{ attr.customData.user_name }} {{ attr.customData.title }}
            </p>
          </div>
        </div>
      </template>
    </v-calendar>
    <div class="modal" :class="{ open_modal: showModal }" data-modal="modal">
      <div class="modal_overlay" data-modal-close="modal"></div>
      <div class="modal_wrap">
        <div class="modal_header">
          <div class="d_flex_btwn">
            <h3>Leave request details - {{ this.leaveData?.label }}</h3>
            <span>
              <span
                data-modal-close="modal"
                class="close_icon close_icon_md"
                @click.prevent="closeModal"
              ></span>
            </span>
          </div>
        </div>
        <div class="modal_inner">
          <div class="modal_content modal_850p">
            <div class="row">
              <div class="col_6 pr_20">
                <div class="form_row_inline">
                  <label class="">Name</label>
                  <div class="form_input">{{ leaveData?.user_name }}</div>
                </div>
                <div class="form_row_inline">
                  <label class="">Start date</label>
                  <div class="form_input">{{ leaveData?.start_date }}</div>
                </div>
                <div class="form_row_inline">
                  <label class="">End date</label>
                  <div class="form_input">{{ leaveData?.end_date }}</div>
                </div>
                <div class="form_row_inline">
                  <label class="">Leave type</label>
                  <div class="form_input">{{ leaveData?.leave_type }}</div>
                </div>
                <div
                  :class="[
                    'form_row_inline',
                    { has_error: errorFor('status') },
                  ]"
                >
                  <label>Status</label>
                  <div class="form_input">
                    <select class="form_global" v-model="form.status">
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                    <v-errors :errors="errorFor('status')"></v-errors>
                  </div>
                </div>
                <div class="form_row_inline">
                  <label></label>
                  <div class="form_input">
                    <button
                      class="btn btn_primary"
                      :disabled="lyLoading"
                      @click.prevent="update"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
              <div class="col_6 pr_20">
                <div class="form_row_inline" v-if="leaveData?.reason">
                  <label class="">Reason</label>
                  <div class="form_input">{{ leaveData?.reason }}</div>
                </div>
                <div v-if="leaveData?.document">
                  <h3>
                    Document
                    <span
                      class="float-right"
                      title="Download document"
                      @click.prevent="downloadFile(leaveData?.document)"
                      ><i class="lni lni-download"></i
                    ></span>
                  </h3>
                  <br />
                  <img :src="leaveData?.document" width="100%" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      showModal: false,
      leaveData: {},
      lyLoading: false,
      form: {
        status: '',
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.axios.get('/leaves-for-calender').then((response) => {
        this.attributes = response.data.data;
      });
    },
    showData(e, data) {
      e.stopPropagation();
      this.leaveData = { ...data };
      this.form.status = this.leaveData.status;
      this.showModal = true;
    },
    closeModal() {
      this.leaveData = {};
      this.showModal = false;
    },
    downloadFile(filePath) {
      const a = document.createElement('a');
      a.href = filePath;
      let filenameArr = filePath.split('/');
      let filename = filenameArr[filenameArr.length - 1];
      a.download = filename;
      a.style.display = `none`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/leaves/' + this.leaveData.id, formData)
        .then(() => {
          this.showSuccessMsg('Leave Update Successfully!');
          this.loadData();
          this.leaveData = {};
          this.showModal = false;
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}

::v-deep(.custom-calendar.vc-container) {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;
}

::v-deep(.custom-calendar.vc-container .vc-header) {
  /* background-color: #f1f5f8; */
  /* padding: 10px 0; */
  height: 48px;
  margin-top: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weeks) {
  padding: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weekday) {
  background-color: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  padding: 5px 0;
}

::v-deep(.custom-calendar.vc-container .vc-day) {
  padding: 0 5px 3px 5px;
  text-align: left;
  height: var(--day-height);
  min-width: var(--day-width);
  background-color: white;
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1),
::v-deep(.custom-calendar.vc-container .vc-day.weekday-7) {
  background-color: #eff8ff;
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-bottom)) {
  border-bottom: var(--day-border);
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1:not(.on-bottom)) {
  border-bottom: var(--day-border-highlight);
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-right)) {
  border-right: var(--day-border);
}

::v-deep(.custom-calendar.vc-container .vc-day-dots) {
  margin-bottom: 5px;
}

::v-deep(.custom-calendar .vc-header .vc-title-wrapper .vc-title) {
  /* opacity: 1 !important; */
  /* background: red !important; */
  /* color: red; */
  background: transparent;
}
::v-deep(.custom-calendar .vc-header .vc-title:hover) {
  opacity: 1;
}

::v-deep(.custom-calendar .vc-weeks .vc-day) {
  text-align: center;
  padding: 5px;
  min-height: 60px;
  height: auto;
}
::v-deep(.custom-calendar .bg-info) {
  background: rgba(66, 153, 225);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-success) {
  background: rgba(56, 178, 172);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-danger) {
  background: rgba(229, 62, 62);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
.color_green {
  color: #16a34a;
}
.text-danger {
  color: #dc2626;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
